<template>
  <div>
    <p class="filter-title">Course de cumul d'intérmediaires</p>

    <router-link
      type="button"
      size="sm"
      class="button_course"
      v-for="course_cumul in $store.state.event.data.courses_cumul"
      :key="course_cumul.nom"
      v-bind:class="{
        isCurrent: $store.state.event.selection.courses_cumul === course_cumul.nom,
      }"
      target="_self"
      :to="{
        name: 'CourseCumul',
        query: { id: $store.state.event.id, cc: course_cumul.nom },
      }"
      refresh
      >{{ course_cumul.nom }}</router-link
    >
  </div>
</template>

<script>
export default {
  components: {},


  data() {
    return {};
  },
};
</script>

<style scoped>
a.button_course {
  background-color: #f29406;
  color: white !important;
  padding: 0.25rem 0.5rem;
  line-height: 1.5;
  border: 1px solid #f29406;
  margin: 2px;
  font-size: 13px;
  border-radius: 3px !important;
}
a.button_course.isCurrent {
  color: #f29406 !important;
}

.button_course a {
  color: inherit !important;
}
</style>
